module.exports = "/_next/static/images/tickets-flying-e95ac12844a2c541444ce4c4063c30df.png";